// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"1beaf4922896ed77f814","351":"276582fcb2d0630852c2","532":"29ff76b274f0b781d28f","691":"bc6053887bc5a9c3c43b"}[chunkId] + ".js";
};